import { Link } from "gatsby";
import { useBreakpoint } from "gatsby-plugin-breakpoints";
import { StaticImage } from "gatsby-plugin-image";
import React from "react";

export default function Header() {
  const breakpoint = useBreakpoint();
  return (
    <header id="landing-header">
      <div>
        <Link to="/">
          {breakpoint.md ? (
            <StaticImage
              src="../../images/logo.svg"
              alt="Julie Lobo"
              width={85}
            />
          ) : (
            <StaticImage
              src="../../images/logo.svg"
              alt="Julie Lobo"
              width={113}
            />
          )}
        </Link>
      </div>
      <nav>
        <ul>
          <li>
            <Link to="/film">
              <span>f</span>ilm
            </Link>
          </li>
          <li>
            <Link to="/photo">
              <span>p</span>hoto
            </Link>
          </li>
          <li>
            <Link to="/design">
              <span>d</span>esign
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}
